// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"Ribbon_ribbon__oulf0","ribbon_text":"Ribbon_ribbon_text__LM9WG","ribbon_svg":"Ribbon_ribbon_svg__OoWJN"};